import React, { useState } from "react";
import InputField from "../sharedComponents/InputField";
import { useDispatch, useSelector } from "react-redux";
import { forgetPassword } from "../../slices/1-auth/1-login/thunk";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import logo from "../../assets/images/Logo.webp";
import { LockClosedIcon } from "@heroicons/react/24/outline";
import MainButton from "../sharedComponents/MainButton";

const ForgetPasswordForm = () => {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);
  const { t } = useTranslation();

  /* ================= STATIC CONTENT ================= */
  const formContent = {
    title: t("forgetPassword.title"),
    subtitle: t("forgetPassword.subtitle"),
    emailPlaceholder: t("forgetPassword.emailPlaceholder"),
    passwordPlaceholder: t("forgetPassword.passwordPlaceholder"),
    signInText: t("forgetPassword.signInText"),
  };

  const {
    title,
    subtitle,
    emailPlaceholder,
    signInText,
  } = formContent;



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error(t("auth.enterEmail"));
      return;
    }

    try {
      const result = await dispatch(forgetPassword({ email })).unwrap();
      toast.success(t("auth.resetLinkSent"));
      setEmail("");
    } catch (err) {
      // toast.error(err || "Something went wrong");
    }
  };

  return (
    <div className="grid min-h-screen grid-cols-1 md:grid-cols-2 ">
      {/* Left Side */}
      <div className="flex-col items-center justify-center hidden min-h-screen text-center md:flex dark:bg-bg-dark-secondary bg-bg-light-secondary">
        <div>
          <img
            src={logo}
            alt={t("login.logoAlt")}
            className="flex items-center justify-center mb-6 rounded-full w-28 h-28 shadow-glow"
          />
        </div>
        <h1 className="mb-4 text-3xl font-bold text-black dark:text-white">{t("login.brandName")}</h1>
        <p className="px-4 text-center text-text-muted-light dark:text-text-muted-dark">
          {t("login.brandSubtitle")}
        </p>
      </div>

      {/* Right Form */}
      <div className="flex flex-col justify-center max-w-lg mx-auto md:my-6 md:gap-2">
        <div className="flex flex-col justify-center md:my-6 md:gap-4 md:mx-12 md:w-full">
          <div className="justify-center md:justify-start">
            <span className="inline-block rounded-full">
              <LockClosedIcon className="w-12 h-12 p-3 rounded-full dark:text-primary text-primary-light dark:bg-bg-dark-tertiary bg-bg-light-tertiary" />
            </span>
            <h2 className="flex items-center gap-2 text-2xl font-bold md:text-3xl text-custom-black">
              {title}
            </h2>
            <p className="mt-3 text-custom-black">{subtitle}</p>
          </div>

          <form className="flex flex-col gap-5 mt-6" onSubmit={handleSubmit}>
            <InputField
              type="email"
              placeholder={emailPlaceholder}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <MainButton
              type="submit"
              disabled={loading}
            >
              {loading ? "Sending..." : signInText}
            </MainButton>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgetPasswordForm;
